<template>
  <!--题库-->
  <div id="exambank">
    <top-head :pageName="pageName"></top-head>
    <h1><router-link to="StudyAim">{{resSubject}} <span class="arrow"></span></router-link></h1>
    <div class="cc" v-for="(item, index) in topData" :key="index">
      <h4>{{item.name}}</h4>
      <div>
        <router-link :to="{name: 'ExamChapter', query: {subject_id: item2.subject_id, is_chapter: item2.is_chapter}}" v-for="(item2, index2) in item.subset" :key="index2" :title="item2.name"><img :src="item2.background_image" :alt="item2.name"></router-link>
      </div>
    </div>
    <!--底部占位-->
    <div id="fix-bottom-void"></div>
    <bottom-bar :index="2"></bottom-bar>
  </div>
</template>

<script>
import BottomBar from '../share/fixed/BottomBar'
import topHead from '../share/header/topHead'
export default {
  name: 'ExamBank',
  data () {
    return {
      subject: this.$store.state.subject ? this.$store.state.subject : 1,
      period: this.$store.state.period ? this.$store.state.period : 2,
      course: 0,
      topData: {},
      pageName: 'ExamBank'
    }
  },
  components: {
    BottomBar,
    topHead
  },
  computed: {
    resSubject: function () {
      let result = ''
      switch (this.$store.state.subject) {
        case 1:
          result = '教师资格-笔试'
          break
        case 2:
          result = '教师资格-面试'
          break
        case 3:
          result = '教师招聘-笔试'
          break
        case 4:
          result = '教师招聘-面试'
          break
        case 0:
        default:
          result = '教师资格-笔试'
          break
      }
      switch (this.$store.state.period) {
        case 1:
          result += '-' + '中学'
          break
        case 2:
          result += '-' + '小学'
          break
        case 3:
          result += '-' + '幼儿'
          break
        case 0:
        default:
          result += '-' + '小学'
          break
      }
      return result
    }
  },
  mounted () {
    this.validateLogin()
    this.getExamList()
  },
  methods: {
    getExamList () {
      let data = {
        subject: this.subject,
        period: this.period,
        course: this.course
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_type_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.topData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin', query: {backto: 'ExamBank'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    validateLogin () {
      if (!this.$store.state.uid) {
        // this.$router.push({name: 'PwdLogin', query: {backto: 'ExamBank'}})
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#exambank
  padding: 0 .4rem
  -webkit-box-sizing: border-box
  -moz-box-sizing: border-box
  box-sizing: border-box
  h1
    margin: .76rem 0 .52rem
    font-size: .4rem
    color: #050505
    font-weight: 600
    span.arrow
      position: relative
      top: -.15rem
      left: .1rem
      display: inline-block
      width: 0
      height: 0
      border-top: .16rem solid #3F3F3F
      border-left: .12rem solid transparent
      border-right: .12rem solid transparent
  .cc
    h4
      margin: .52rem 0 .32rem
      font-size: .4rem
      color: #050505
      font-weight: 600
    & > div
      display: flex
      justify-content: space-between
      align-items: center
      img
        width: 1.96rem
        height: 2.6rem
  #fix-bottom-void
    height: 1rem
    clear: both
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamBank.vue